/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig';

export class LlgResourcePolicy {
  /**
  * ID of the vault used by this policy.
  */
  'vaultId': string;
  /**
  * Backup retention period, in days.
  */
  'backupRetentionDays': number;
  'scheduleConfig': HighFrequencyBackupScheduleConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": ""
    },
    {
      "name": "scheduleConfig",
      "baseName": "scheduleConfig",
      "type": "HighFrequencyBackupScheduleConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LlgResourcePolicy.attributeTypeMap;
  }

  public constructor() {
  }
}

